// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"AutocompleteQueryTextHighlightOption__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Autocomplete/AutocompleteQueryTextHighlightOption.scss
 ** module id = 888
 ** module chunks = 1
 **/